import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../contexts/AppContext';
import PurchaseDocumentFormContainer from './PurchaseDocumentFormContainer';
import { toast } from 'react-toastify';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { PurchaseDocumentDataForm, PurchaseDocumentPaymentDataForm } from '../../../app/models/PurchaseDocument';
import usePurchaseDocumentService from '../../../app/services/hooks/usePurchaseDocumentService';
import { PurchaseDocumentDetail } from '../../../app/models/PurchaseDocumentDetail';
import { PurchaseDocumentHistoryDataForm } from '../../../app/models/PurchaseDocumentHistory';
import { Society } from '../../../app/models/Society';
import NoteFormContainer from './NoteFormContainer';
import { NoteCauses, NoteTypes } from '../../../app/models/PurchaseDocument';
import { Tax } from '../../../app/models/Tax';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { Provider } from '../../../app/models/Provider';
import useTaxDocumentService from '../../../app/services/hooks/useTaxDocumentService';


interface Props {
    purchaseDocumentId: number;
    purchaseDocumentDetailId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    setPurchaseDocumentDetailTable: (purchaseDocumentDetail: PurchaseDocumentDetail[]) => void;
    reloadPurchaseDocumentTable: () => void;
    setPurchaseDocumentHistoryTable: (purchaseDocumentHistory: PurchaseDocumentHistoryDataForm[]) => void;
    // reloadPurchaseDocumentHistoryTable: () => void;
}

const PurchaseDocumentsEdit = ({ 
    purchaseDocumentId, 
    purchaseDocumentDetailId,
    onSaved,
    onCancel,
    onError 
}: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const { editPurchaseDocument, fetchingEditPurchaseDocument, updatePurchaseDocument } = usePurchaseDocumentService();
    const { updateNote } = useTaxDocumentService();
    const [purchaseDocument, setPurchaseDocument] = useState<PurchaseDocumentDataForm>({});
    const [errorFields, setErrorFields] = useState<any>();
    const [paymentStatuses, setPaymentStatuses] = useState<PurchaseDocumentPaymentDataForm[]>([]); 
    const [societies, setSocieties] = useState<Society[]>([]);
    const [providers, setProviders] = useState<Provider[]>([]);

    const [taxes, setTaxes] = useState<Tax[]>([]);
    const isNoteType = purchaseDocument.document_type_obj?.id === 'NOTA_CREDITO' || purchaseDocument.document_type_obj?.id === 'NOTA_DEBITO';
    const [noteTypes, setNoteTypes] = useState<NoteTypes[]>([]);
    const [causes, setCauses] = useState<NoteCauses[]>([]);

    // Payment statuses


    useEffect(() => {
        reloadModule();
    }, [purchaseDocumentId]);


    const edit = (purchaseDocumentId: number) => {
        if (showLoading) showLoading('loading', 'Cargando documento de venta...');
        
        editPurchaseDocument(purchaseDocumentId, {
            onSuccess: (response: ServiceResponse) => {
                const _purchase_document = response.data.purchase_document;
    
                _purchase_document.taxes = [];
    
                setPurchaseDocument(_purchase_document);
                setPaymentStatuses(response.data.service_manifest_detail);
                setSocieties(response.data.societies);
                setProviders(response.data.providers);
                setTaxes(response.data.taxes);
    
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando documento de venta...');
        const updateMethod = isNoteType ? updateNote : updatePurchaseDocument;
        updateMethod(purchaseDocumentId!, purchaseDocument, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.success(response.message);
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message,
                    message_list: response.data.message_list ?? []
                });
            
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        }, false); // Pasa `false` como cuarto argumento
    };
    
    const reloadModule = () => {
        edit(purchaseDocumentId);
    };


    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditPurchaseDocument ? (
        <div>Cargando...</div>
    ) : isNoteType ? (
        <NoteFormContainer
            action={update}
            cancel={cancel}
            note={purchaseDocument}
            setNote={setPurchaseDocument}
            societies={societies}
            providers={providers}
            setNoteTypes = {setNoteTypes}
            causes={causes}
            setCauses={setCauses}
            noteTypes={noteTypes}
            taxesData={taxes}
            availableStatuses={paymentStatuses}
            errorFields={errorFields}
            updated={true}
            disabled={true}
            purchaseDocuments={[]}
        />
    ) : (
        <PurchaseDocumentFormContainer
            action={update}
            cancel={cancel}
            purchaseDocument={purchaseDocument}
            setPurchaseDocument={setPurchaseDocument}
            societies={societies}
            providers={providers}
            errorFields={errorFields}
            availableStatuses={paymentStatuses}
            updated={true}
            disabled={true}
        />
    );
};

export default PurchaseDocumentsEdit;
